import productApi from '@/api/productApi'
import currencyApi from '@/api/currencyApi'

const UPDATE_FILTER = 'UPDATE_FILTER'
const SET_PROVIDERS = 'SET_PROVIDERS'
const SET_CURRENCIES = 'SET_CURRENCIES'
const SET_LOADING = 'SET_LOADING'

// initial state
const state = {
  filter: {},
  providers: [],
  currencies: [],
  loading: false
}

// getters
const getters = {
  filter: state => state.filter,
  providers: state => state.providers,
  loading: state => state.loading
}

// actions
const actions = {
  getCurrencies ({commit}) {
    commit(SET_LOADING, true)
    currencyApi.getCurrencies()
      .then(response => {
        commit(SET_CURRENCIES, response.data.results)
        commit(SET_LOADING, false)
      })
  },
  getProviders ({commit}) {
    commit(SET_LOADING, true)
    productApi.getProviders()
      .then(response => {
        commit(SET_PROVIDERS, response.data)
        commit(SET_LOADING, false)
      })
  },
  isLoading ({commit, state}, isLoading) {
    commit(SET_LOADING, isLoading)
  }
}

// mutations
const mutations = {
  [UPDATE_FILTER] (state, filter) {
    state.filter = filter
  },
  [SET_LOADING] (state, loading) {
    state.loading = loading
  },
  [SET_PROVIDERS] (state, providers) {
    state.providers = providers
  },
  [SET_CURRENCIES] (state, currencies) {
    state.currencies = currencies
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/searchFilter.js